<template>
  <div class="prescription-detail">
    <div class="left">
      <descriptions title="基础信息" column="2" :labelStyle="{ width: '70px', color: '#595959' }">
        <descriptions-item :span="2" label="处方编号">{{ detail.prescriptionId }}</descriptions-item>
        <descriptions-item :span="2" label="所属药店">
          {{ detail.storeName }}
        </descriptions-item>
        <descriptions-item :span="2" label="医疗机构">{{ detail.hospitalName }}</descriptions-item>
        <descriptions-item :span="2" label="处方平台">{{ detail.platformName }}</descriptions-item>
        <descriptions-item :span="2" label="上传时间">{{ detail.uploadTime }}</descriptions-item>
      </descriptions>
      <div class="divider-line"></div>
      <descriptions column="2" :labelStyle="{ color: '#595959' }">
        <descriptions-item :span="2" label="医生姓名">{{ detail.doctorName }}</descriptions-item>
        <descriptions-item :span="2" label="医生执业资格证号">{{ detail.doctorCertNo }}</descriptions-item>
        <descriptions-item :span="2" label="开方时间">
          {{ detail.prescriptionTime | formatTime }}
        </descriptions-item>
      </descriptions>
      <div class="divider-line"></div>
      <descriptions column="2" :labelStyle="{ color: '#595959' }">
        <descriptions-item :span="2" label="药师姓名" v-if="detail.pharmacistName">
          {{ detail.pharmacistName }}
        </descriptions-item>
        <descriptions-item :span="2" label="药师执业资格证号" v-if="detail.pharmacistCertNo">
          {{ detail.pharmacistCertNo }}
        </descriptions-item>
        <descriptions-item :span="2" label="审方时间" v-if="detail.pharmacistAuditTime">
          {{ detail.pharmacistAuditTime | formatTime }}
        </descriptions-item>
      </descriptions>
      <div class="block"></div>
      <descriptions title="用药人信息" column="2" :labelStyle="{ color: '#595959' }">
        <descriptions-item :span="2" label="姓名">{{ detail.patientName }}</descriptions-item>
        <descriptions-item v-if="detail.guardianName" :span="2" label="监护人">
          {{ detail.guardianName }}
        </descriptions-item>
        <descriptions-item :span="2" label="性别">{{ detail.patientSex | mapSex }}</descriptions-item>
        <descriptions-item v-if="detail.guardianMobile" :span="2" label="监护人电话">
          {{ detail.guardianMobile }}
        </descriptions-item>
        <descriptions-item :span="2" label="年龄">{{ detail.patientAge }}</descriptions-item>
        <descriptions-item v-if="detail.guardianCardNo" :span="2" label="监护人身份证号码">
          {{ detail.guardianCardNo }}
        </descriptions-item>
        <descriptions-item :span="2" label="证件类型">{{ detail.idcardType | mapIdcardType }}</descriptions-item>
        <descriptions-item :span="2" label="证件号码">{{ detail.idcardNo }}</descriptions-item>
      </descriptions>
      <div class="block"></div>
      <div v-for="(drug, i) in detail.drugsInfo" :key="i">
        <descriptions :title="i === 0 ? '用药信息' : null" column="2" :labelStyle="{ color: '#595959' }">
          <descriptions-item :span="2" label="药品名称">{{ drug.drugName }} {{ drug.drugSpec }}</descriptions-item>
          <descriptions-item :span="2" label="数量">{{ `${drug.drugNum} ${drug.drugUnit}` }}</descriptions-item>
          <descriptions-item :span="2" label="用法用量">
            {{ `${drug.usageWay}，${drug.usageFrequency}，${drug.usagePerNum}` }}
          </descriptions-item>
          <descriptions-item :span="2" label="用药天数" v-if="drug.usageNum">
            {{ `${drug.usageNum}` }}
          </descriptions-item>
          <descriptions-item :span="2" label="生产厂家" v-if="drug.drugManufacturer">
            {{ drug.drugManufacturer }}
          </descriptions-item>
          <descriptions-item v-if="drug.barCode" :span="2" label="药品条形码">
            {{ drug.barCode }}
          </descriptions-item>
          <descriptions-item :span="2" label="批准文号" v-if="drug.approvalNumber">
            {{ drug.approvalNumber }}
          </descriptions-item>
        </descriptions>
        <div class="divider-line"></div>
      </div>
      <div class="block"></div>
      <descriptions
        v-if="detail.inquiryFileUrl && prescriptionShow"
        title="问诊文件"
        column="2"
        :labelStyle="{ color: '#595959' }"
      >
        <descriptions-item :span="2" label="问诊方式">
          <div>
            {{ detail.inquiryType | mapInquiryType }}
            <a style="margin-left: 12px; color: #0b3a6b; cursor: pointer" @click="dialogVisible = true">点击查看</a>
          </div>
        </descriptions-item>
      </descriptions>
      <div class="desc" v-if="detail.inquiryFileUrl && prescriptionShow">该文件为电子处方平台上传</div>
    </div>
    <div class="right">
      <div class="title">处方笺文</div>
      <el-image
        :style="imageStyle"
        :src="detail.prescriptionImgUrl"
        :preview-src-list="[detail.prescriptionImgUrl]"
        alt=""
      />
      <div class="desc">该文件为电子处方平台上传</div>
    </div>
    <el-dialog class="supervision-dialog" title="问诊文件" :visible.sync="dialogVisible" width="50%" destroy-on-close>
      <el-image
        v-if="isImage(detail.inquiryFileUrl)"
        :src="detail.inquiryFileUrl"
        :preview-src-list="[detail.inquiryFileUrl]"
      ></el-image>
      <iframe v-else width="100%" style="border: none; height: 80vh" :src="detail.inquiryFileUrl"></iframe>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { transformPrescriptionImageByCss, getFileSuffix } from '@/util';
import descriptions from './components/prescriptionSupervision/descriptions';
import descriptionsItem from './components/prescriptionSupervision/descriptions-item';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'prescription-detail',
  components: { descriptions, descriptionsItem },
  data() {
    return { dialogVisible: false, detail: {}, imageStyle: {} };
  },
  filters: {
    mapSex(val) {
      return val === 0 ? '女' : '男';
    },
    mapIdcardType(val) {
      return val === 0 ? '身份证' : '护照';
    },
    mapInquiryType(val) {
      return val === 0 ? '图文' : '视频';
    },
    formatTime(val) {
      return val ? dayjs(val).format('YYYY-MM-DD HH:mm:ss') : '';
    }
  },
  computed: {
    ...mapState('permission', ['supervisionConfig']),
    prescriptionShow() {
      return !this.supervisionConfig?.prescriptionConfig?.hiddenInquiryFile;
    },
    ...mapGetters(['storeList']),
    storeId() {
      // 多店业务上暂时不考虑
      const { storeList } = this;
      return Array.isArray(storeList) ? storeList?.[0].id : storeList?.id;
    }
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      const { prescriptionId, creditCode, prescriptionRegistrationId } = this.$route.query;

      const { storeId } = this;

      const res = await Fetch.getElectronicPrescriptionDetail({
        storeId,
        prescriptionId,
        creditCode,
        prescriptionRegistrationId
      });

      this.detail = res;

      transformPrescriptionImageByCss(res?.prescriptionImgUrl, style => (this.imageStyle = style));
    },
    isImage(src) {
      return ['png', 'jpg', 'jpeg', 'gif'].includes(getFileSuffix(src));
    }
  }
};
</script>

<style lang="scss" scoped>
.prescription-detail {
  display: flex;
  gap: 16px;
  padding: 0 16px 16px;
  background-color: #f7f8fa;

  .left {
    flex: 1;
    padding: 24px 22px;
    background-color: #fff;

    .divider-line {
      margin-bottom: 12px;
      width: 100%;
      height: 1px;
      background-color: #e6e6e6;
    }

    .block {
      width: 100%;
      height: 24px;
    }
  }

  .right {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px;
    width: 443px;
    min-height: 868px;
    background-color: #fff;

    .title {
      margin-bottom: 13px;
      font-size: 16px;
      font-weight: 500;
      color: #262626;
      line-height: 24px;
    }

    img {
      width: 100%;
    }
  }
  .desc {
    font-size: 10px;
    color: #666;
  }
}
</style>
